<div #content class="content" [class.collapsed]="collapsed" (window:resize)="onResize($event)">
  <div class="dissolve" [hidden]="!collapsed"></div>
  <span [innerHTML]="html"></span>
</div>
<div class="my-2"
  ><a href="#" (click)="expand($event)" [hidden]="!collapsed" class="small" data-cy="see-more-text">{{
    seeMoreText
  }}</a></div
>
